<template>
  <obj-box
    :url="`/mass_pending/${massPendingId}/info`"
    typeName="Mass pending"
    :objId="massPendingId"
    v-slot="{obj: massPending}"
  >
    <table class="prop-table mb-4">
      <tr>
        <th>Time</th>
        <td>{{massPending.ctime | getMomentMinStr}}</td>
      </tr>
      <tr>
        <th>User</th>
        <td>
          <user-link
            :user="massPending.user"
          />
        </td>
      </tr>
      <tr>
        <th>Players amount</th>
        <td>{{massPending.playersAmount | getFormattedNumber}}</td>
      </tr>
      <tr>
        <th>Letter</th>
        <td>{{massPending.letter | getOptionalStringDefaultStr('not specified')}}</td>
      </tr>
    
      <tr>
        <td colspan="2" class="pt-4">
          <h4>Product</h4>
        </td>
      <tr>
      <tr>
        <th>Type</th>
        <td>{{massPending.productId | getProtoAlias}}</td>
      </tr>
      <tr>
        <th>Amount</th>
        <td>{{massPending.amount | getFormattedNumber}}</td>
      </tr>
    </table>
  </obj-box>
</template>

<script>
import ObjBox from './util/ObjBox.vue';
import UserLink from './UserLink.vue';

export default {
  name: 'MassPendingInfo',

  components: {
    ObjBox,
    UserLink,
  },

  props: {
    massPendingId: {
      type: Number,
      required: true,
    },
  },
}
</script>
